!(function () {
  'use strict'
  angular.module('paging', []).factory('paging', [
    '$parse',
    function (e) {
      return {
        create: function (a, n, t) {
          ;(a.setNumPages = t.numPages ? e(t.numPages).assign : angular.noop),
            (a.ngModelCtrl = { $setViewValue: angular.noop }),
            (a.init = function (i, r) {
              ;(a.ngModelCtrl = i),
                (a.config = r),
                (i.$render = function () {
                  a.render()
                }),
                t.itemsPerPage
                  ? n.$parent.$watch(e(t.itemsPerPage), function (e) {
                      ;(a.itemsPerPage = parseInt(e, 10)),
                        (n.totalPages = a.calculateTotalPages()),
                        a.updatePage()
                    })
                  : (a.itemsPerPage = r.itemsPerPage),
                n.$watch('totalItems', function (e, t) {
                  ;(angular.isDefined(e) || e !== t) &&
                    ((n.totalPages = a.calculateTotalPages()), a.updatePage())
                })
            }),
            (a.calculateTotalPages = function () {
              var e =
                a.itemsPerPage < 1
                  ? 1
                  : Math.ceil(n.totalItems / a.itemsPerPage)
              return Math.max(e || 0, 1)
            }),
            (a.render = function () {
              n.page = parseInt(a.ngModelCtrl.$viewValue, 10) || 1
            }),
            (n.selectPage = function (e, t) {
              t && t.preventDefault()
              var i = !n.ngDisabled || !t
              i &&
                n.page !== e &&
                e > 0 &&
                e <= n.totalPages &&
                (t && t.target && t.target.blur(),
                a.ngModelCtrl.$setViewValue(e),
                a.ngModelCtrl.$render())
            }),
            (n.getText = function (e) {
              return n[e + 'Text'] || a.config[e + 'Text']
            }),
            (n.noPrevious = function () {
              return 1 === n.page
            }),
            (n.noNext = function () {
              return n.page === n.totalPages
            }),
            (a.updatePage = function () {
              a.setNumPages(n.$parent, n.totalPages),
                n.page > n.totalPages
                  ? n.selectPage(n.totalPages)
                  : a.ngModelCtrl.$render()
            })
        }
      }
    }
  ]),
    angular
      .module('pagination', ['paging'])
      .controller('PaginationController', [
        '$scope',
        '$attrs',
        '$parse',
        'paging',
        'paginationConfig',
        function (e, a, n, t, i) {
          function r (e, a, n) {
            return { number: e, text: a, active: n }
          }
          function s (e, a) {
            var n = [],
              t = 1,
              i = a,
              s = angular.isDefined(g) && g < a
            s &&
              (o
                ? ((t = Math.max(e - Math.floor(g / 2), 1)),
                  (i = t + g - 1),
                  i > a && ((i = a), (t = i - g + 1)))
                : ((t = (Math.ceil(e / g) - 1) * g + 1),
                  (i = Math.min(t + g - 1, a))))
            for (var l = t; l <= i; l++) {
              var p = r(l, l, l === e)
              n.push(p)
            }
            if (s && g > 0 && (!o || u || c)) {
              if (t > 1) {
                if (!c || t > 3) {
                  var f = r(t - 1, '...', !1)
                  n.unshift(f)
                }
                if (c) {
                  if (3 === t) {
                    var d = r(2, '2', !1)
                    n.unshift(d)
                  }
                  var P = r(1, '1', !1)
                  n.unshift(P)
                }
              }
              if (i < a) {
                if (!c || i < a - 2) {
                  var v = r(i + 1, '...', !1)
                  n.push(v)
                }
                if (c) {
                  if (i === a - 2) {
                    var m = r(a - 1, a - 1, !1)
                    n.push(m)
                  }
                  var $ = r(a, a, !1)
                  n.push($)
                }
              }
            }
            return n
          }
          var l = this,
            g = angular.isDefined(a.maxSize)
              ? e.$parent.$eval(a.maxSize)
              : i.maxSize,
            o = angular.isDefined(a.rotate)
              ? e.$parent.$eval(a.rotate)
              : i.rotate,
            u = angular.isDefined(a.forceEllipses)
              ? e.$parent.$eval(a.forceEllipses)
              : i.forceEllipses,
            c = angular.isDefined(a.boundaryLinkNumbers)
              ? e.$parent.$eval(a.boundaryLinkNumbers)
              : i.boundaryLinkNumbers
          ;(e.boundaryLinks = angular.isDefined(a.boundaryLinks)
            ? e.$parent.$eval(a.boundaryLinks)
            : i.boundaryLinks),
            (e.directionLinks = angular.isDefined(a.directionLinks)
              ? e.$parent.$eval(a.directionLinks)
              : i.directionLinks),
            t.create(this, e, a),
            a.maxSize &&
              e.$parent.$watch(n(a.maxSize), function (e) {
                ;(g = parseInt(e, 10)), l.render()
              })
          var p = this.render
          this.render = function () {
            p(),
              e.page > 0 &&
                e.page <= e.totalPages &&
                (e.pages = s(e.page, e.totalPages))
          }
        }
      ])
      .constant('paginationConfig', {
        itemsPerPage: 10,
        boundaryLinks: !1,
        boundaryLinkNumbers: !1,
        directionLinks: !0,
        firstText: 'First',
        previousText: 'Previous',
        nextText: 'Next',
        lastText: 'Last',
        rotate: !0,
        forceEllipses: !1
      })
      .directive('gridPagination', [
        '$parse',
        'paginationConfig',
        function (e, a) {
          return {
            scope: {
              totalItems: '=',
              firstText: '@',
              previousText: '@',
              nextText: '@',
              lastText: '@',
              ngDisabled: '='
            },
            require: ['gridPagination', '?ngModel'],
            controller: 'PaginationController',
            controllerAs: 'pagination',
            templateUrl: function (e, a) {
              return a.templateUrl || 'src/template/pagination/pagination.html'
            },
            replace: !0,
            link: function (e, n, t, i) {
              var r = i[0],
                s = i[1]
              s && r.init(s, a)
            }
          }
        }
      ])
      .run([
        '$templateCache',
        function (e) {
          e.put(
            'src/template/pagination/pagination.html',
            "<ul class='pagination'><li ng-if='::boundaryLinks' ng-class='{disabled: noPrevious()||ngDisabled}' class='pagination-first'><a href ng-click='selectPage(1, $event)'>{{::getText('first')}}</a></li> <li ng-if='::directionLinks' ng-class='{disabled: noPrevious()||ngDisabled}' class='pagination-prev'><a href ng-click='selectPage(page - 1, $event)'>{{::getText('previous')}}</a></li> <li ng-repeat='page in pages track by $index' ng-class='{active: page.active,disabled: ngDisabled&&!page.active}' class='pagination-page'><a href ng-click='selectPage(page.number, $event)'>{{page.text}}</a></li> <li ng-if='::directionLinks' ng-class='{disabled: noNext()||ngDisabled}' class='pagination-next'><a href ng-click='selectPage(page + 1, $event)'>{{::getText('next')}}</a></li> <li ng-if='::boundaryLinks' ng-class='{disabled: noNext()||ngDisabled}' class='pagination-last'><a href ng-click='selectPage(totalPages, $event)'>{{::getText('last')}}</a></li> </ul>"
          )
        }
      ])
})()
